import bindSocketUserEvents from './binds';

export default socketMiddleware => {
    bindSocketUserEvents(socketMiddleware);
    // let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    return {};
};



// WEBPACK FOOTER //
// ./environments/myfhe/eventsSocket/User/index.js